"use client";

import type { AnnouncementBannerEntry } from "@/lib/contentful/announcementBanner";
import { AnnouncementBannerView } from "./AnnouncementBannerView";
import { LivePersonalizedEntry } from "./LivePersonalizedEntry";

interface Props {
  initialData: AnnouncementBannerEntry;
}

export function AnnouncementBannerClient({ initialData }: Props) {
  return (
    <LivePersonalizedEntry
      variant={{ id: initialData.sys.id, fields: initialData.fields }}
      view={AnnouncementBannerView}
    />
  );
}
